document.addEventListener('DOMContentLoaded', function () {
  const searchClient = algoliasearch('UF9F9176JU', '5f705dc7cabbfaaf564b06ebb7c59aa8');
  const shopifyText = document.getElementById('algolia-shopify-data').dataset;

  function getExcerpt(hit, wordLimit = 30) {
    if (hit.excerpt) return hit.excerpt;

    if (hit.body_html) {
      // Strip HTML tags
      const text = hit.body_html.replace(/<[^>]+>/g, '');
      // Split into words and truncate
      const words = text.split(/\s+/).slice(0, wordLimit).join(' ');
      return words + '...';
    }

    return ''; // No content fallback
  }

  function formatPublishedDate(hit) {
    if (!hit.published_at) return '';

    const date = new Date(hit.published_at);

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}.${day}.${year}`;
  }

  const indexName = shopifyText.indexPrefix + 'articles' + shopifyText.indexSuffix;
  const search = instantsearch({
    indexName: indexName,
    searchClient,
    routing: instantsearch.routers.history() // Optional, lets you share URLs
  });

  // --- Custom Render: Tag Filters ---
  const renderTagFilters = instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
    const { items, refine, widgetParams } = renderOptions;
    const container = widgetParams.container;
    if (!container) return;

    if (isFirstRender) {
      // Add click listeners once
      container.addEventListener('click', (e) => {
        if (e.target.matches('.quick-filter')) {
          refine(e.target.dataset.value);
        }
      });
    }

    // Always sort alphabetically (ignores selection order)
    const sortedItems = [...items].sort((a, b) => a.label.localeCompare(b.label));

    // Render all available tags
    container.innerHTML = sortedItems
      .map(
        (item) => `
            <button
              class="blog-filters__tag-button button quick-filter ${
                item.isRefined ? 'active button--primary' : 'button--secondary'
              }"
              data-value="${item.value}"
            >
              ${item.label}
            </button>`
      )
      .join('');
  });

  // --- Custom Render: Search Box ---
  const renderSearchBox = instantsearch.connectors.connectSearchBox((renderOptions, isFirstRender) => {
    const { query, refine } = renderOptions;
    const container = document.querySelector('#algolia-searchbox');

    if (isFirstRender) {
      container.innerHTML = `
        <button type="button" id="algolia-search-button" class="algolia-search-icon">
          <span class="svg-wrapper">
            <svg fill="none" class="icon icon-search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path fill="currentColor" fill-rule="evenodd" d="M12.323 13.383a5.5 5.5 0 1 1 1.06-1.06l2.897 2.897a.75.75 0 1 1-1.06 1.06l-2.897-2.897Zm.677-4.383a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"/>
            </svg>
          </span>
        </button>
        <input
          type="search"
          placeholder="Search"
          name="algolia-search"
          id="algoliaBlogSearchInput"
          class="algolia-search-input"
        />
      `;
      const input = container.querySelector('input');
      const button = container.querySelector('#algolia-search-button');

      input.addEventListener('input', (e) => refine(e.target.value));
      button.addEventListener('click', () => refine(input.value));
    }

    container.querySelector('input').value = query;
  });

  // --- Custom Render: Articles Returned Count ---
  // Custom results count that handles query + tag filter
  function resultsCountWithTags({ container, attribute }) {
    let currentQuery = '';
    let currentTag = null;

    // Stats connector
    const statsWidget = instantsearch.connectors.connectStats((renderOptions, isFirstRender) => {
      const { nbHits, widgetParams } = renderOptions;

      // Only render when appropriate
      if ((!currentQuery || currentQuery.trim() === '') && !currentTag) {
        container.innerHTML = '';
        return;
      }

      // Build message parts
      let parts = [];
      if (currentQuery && currentQuery.trim() !== '') {
        parts.push(`"${currentQuery}"`);
      }
      if (currentTag) {
        parts.push(`"${currentTag}"`);
      }

      const joined = parts.join(' and ');

      const plural = nbHits === 1 ? '' : 's';
      container.innerHTML = `
        <div class="results-count">
          ${nbHits} result${plural} for ${joined}
        </div>
      `;
    });

    // Connector for tags, to detect which tag is selected
    const tagListWidget = instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
      const { items, refine } = renderOptions;
      const selected = items.find((item) => item.isRefined);
      currentTag = selected ? selected.value : null;
      // Force a stats re-render? (Stats automatically re-runs when a refinement changes)
      // So no manual trigger needed usually.
    });

    // Connector for search box to capture query
    const searchBoxWidget = instantsearch.connectors.connectSearchBox((renderOptions, isFirstRender) => {
      currentQuery = renderOptions.query;
    });

    return [
      statsWidget({ container }),
      tagListWidget({ attribute }), // attribute should be your tags attribute, e.g. 'tags'
      searchBoxWidget({})
    ];
  }

  // --- Custom Render: Hits (Article Cards) ---
  const renderHits = instantsearch.connectors.connectHits((renderOptions) => {
    const { hits } = renderOptions;
    const container = document.querySelector('#article-cards');

    container.innerHTML = hits
      .map((hit) => {
        const excerpt = getExcerpt(hit);
        const formattedDate = formatPublishedDate(hit);
        const urlLocale = shopifyText.siteName === 'smith' ? '/' + shopifyText.locale : '';
        const articleURL = `${urlLocale}/blogs/blog/${hit.handle}`;

        return `
          <div class="article-card-wrapper card-wrapper underline-links-hover">
          <div
              class="
              card article-card card--standard article-card__image--medium card--media" style="--ratio-percent: ${100}%;">
              <div
              class="card__inner color-scheme-2 gradient ratio"
              style="--ratio-percent: ${100}%;"
              >
              ${
                hit.image
                  ? `
                  <div class="article-card__image-wrapper">
                  <div class="article-card__image media media--hover-effect">
                      <img
                      src="${hit.image}"
                      alt="${hit.image_alt || hit.title}"
                      loading="lazy"
                      class="motion-reduce"
                      />
                  </div>
                  </div>
              `
                  : ''
              }
              <div class="card__content">
                  <div class="card__information">
                  <div class="article-card__info caption-with-letter-spacing--medium">
                      ${hit.tags?.length ? `<span class="article-card__tags">${hit.tags.join(' / ')}</span>` : ''}
                      ${formattedDate ? `<span class="circle-divider">${formattedDate}</span>` : ''}
                  </div>
                  <h3 class="card__heading h4">
                      <a href="${articleURL}" class="full-unstyled-link">
                      ${hit.title}
                      </a>
                  </h3>
                    <div class="article-card__excerpt-wrapper">
                    <p class="article-card__excerpt rte-width caption-large">
                        ${excerpt}
                        <a href="${articleURL}" class="full-unstyled-link article-card__read-more">
                        Read more
                        </a>
                    </p>
                    </div>
                    ${
                      hit.comments_count > 0
                        ? `
                        <div class="article-card__footer">
                        <span>${hit.comments_count} comments</span>
                        </div>
                    `
                        : ''
                    }
                  </div>
                  ${
                    hit.show_badge
                      ? `
                  <div class="card__badge">
                      <span class="badge color-background-1">Blog</span>
                  </div>
                  `
                      : ''
                  }
              </div>
              </div>
              <div class="card__content">
                  <div class="card__information">
                  <div class="article-card__info caption-with-letter-spacing--medium"
                      ${hit.tags?.length ? `<span class="article-card__tags">${hit.tags.join(' / ')}</span>` : ''}
                      ${formattedDate ? `<span class="circle-divider">${formattedDate}</span>` : ''}
                  </div>
                  <h3 class="card__heading h4">
                      <a href="${articleURL}" class="full-unstyled-link">
                      ${hit.title}
                      </a>
                  </h3>
                    <div class="article-card__excerpt-wrapper">
                    <p class="article-card__excerpt rte-width caption-large">
                        ${excerpt}
                        <a href="${articleURL}" class="full-unstyled-link article-card__read-more">
                        Read more
                        </a>
                    </p>
                    </div>
                  ${
                    hit.comments_count > 0
                      ? `
                      <div class="article-card__footer">
                      <span>${hit.comments_count} comments</span>
                      </div>
                  `
                      : ''
                  }
                  </div>
                  ${
                    hit.show_badge
                      ? `
                  <div class="card__badge">
                      <span class="badge color-background-1">Blog</span>
                  </div>
                  `
                      : ''
                  }
              </div>
          </div>
          </div>
      `;
      })
      .join('');
  });

  // --- Custom Render: Pagination ---
  const renderPagination = instantsearch.connectors.connectPagination((renderOptions) => {
    const { currentRefinement, nbPages, refine, createURL, pages, isFirstPage, isLastPage } = renderOptions;

    const container = document.querySelector('#pagination');

    if (!nbPages) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML = `
      <div class="pagination-wrapper" data-page="${currentRefinement}">
        <nav class="pagination" role="navigation" aria-label="Pagination">
          <ul class="pagination__list list-unstyled" role="list">
            ${
              !isFirstPage
                ? `
              <li>
                <a
                  href="${createURL(currentRefinement - 1)}"
                  class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                  aria-label="Previous page"
                  data-page="${currentRefinement - 1}"
                >
                  <span class="svg-wrapper">&lt;</span>
                </a>
              </li>
            `
                : ''
            }
  
            ${pages
              .map(
                (page) => `
              <li>
                ${
                  page === currentRefinement
                    ? `
                  <span
                    class="pagination__item pagination__item--current light"
                    aria-current="page"
                    aria-label="Page ${page + 1}"
                  >
                    ${page + 1}
                  </span>
                `
                    : `
                  <a
                    href="${createURL(page)}"
                    class="pagination__item link"
                    aria-label="Page ${page + 1}"
                    data-page="${page}"
                  >
                    ${page + 1}
                  </a>
                `
                }
              </li>
            `
              )
              .join('')}
  
            ${
              !isLastPage
                ? `
              <li>
                <a
                  href="${createURL(currentRefinement + 1)}"
                  class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
                  aria-label="Next page"
                  data-page="${currentRefinement + 1}"
                >
                  <span class="svg-wrapper">&gt;</span>
                </a>
              </li>
            `
                : ''
            }
          </ul>
        </nav>
      </div>
    `;
  });

  // Add widgets to search
  search.addWidgets([
    instantsearch.widgets.configure({
      hitsPerPage: 6
    }),
    renderTagFilters({
      container: document.querySelector('#algolia-quick-filters'),
      attribute: 'tags'
    }),
    renderSearchBox({}),
    ...resultsCountWithTags({
      container: document.querySelector('#algolia-results-count'),
      attribute: 'tags'
    }),
    renderHits({}),
    renderPagination({})
  ]);

  search.start();
});
